<div class="container-fluid p-0 h-100" id="timecards">
    <div class="row top_card_section context-menu">
        <div class="col-md-6 col-lg-3 mb-3 time-card-column" *ngFor="let item of leavesCards; let i = index; trackBy: trackByName">
            <div class="card shadow-sm card-stretch rounded-0 p-0 h-85px">
                <div class="card-body py-2 p-5">
                    <div class="d-flex align-items-top no-guttrs justify-content-between">
                        <div class="d-flex">
                            <div *ngIf="isLoaded && !isEmpty">
                                <div
                                    class="align-items-center text-center usercardground rounded"
                                    [ngClass]="{ ArrivalTimebackground: item.name === 'Arrival Time', timeAtWork: item.name === 'Time At Work' }"
                                >
                                    <img [src]="item.icon" class="w-xxl-40px w-md-30px" />
                                </div>
                            </div>

                            <div *ngIf="!isLoaded && isEmpty">
                                <div class="row pl-3">
                                    <div class="col-3">
                                        <div class="row">
                                            <div class="col-12">
                                                    <ngx-shimmer-loading [width]="'40px'" [height]="'40px'"></ngx-shimmer-loading>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9">
                                        <div class="row mt-1 no-gutters">
                                            <div class="col-12">
                                                    <ngx-shimmer-loading [width]="'120px'" [height]="'15px'"></ngx-shimmer-loading>
                                            </div>

                                            <div class="col-12 border-0 rounded-2 mt-2" >
                                                    <ngx-shimmer-loading [width]="'120px'" [height]="'15px'"></ngx-shimmer-loading>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="isLoaded && !isEmpty">
                                <div class="font-weight-bold" style="font-size: 16">
                                    <span class="userInfo ml-2"> {{ item.name | localize }}</span>
                                    <div *ngIf="i == 2" class="float-right ml-2">
                                        <span placement="bottom" [tooltip]="tooltipmsg2" container="body">
                                            <i class="la la-info-circle" title=""></i>
                                        </span>
                                        <ng-template #tooltipmsg2>
                                            {{ "Totaltimespentonproductiveapps" | localize }}
                                        </ng-template>
                                    </div>
                                    <div *ngIf="i == 3" class="float-right ml-2">
                                        <span placement="bottom" [tooltip]="tooltipmsg3" container="body">
                                            <i class="la la-info-circle" title=""></i>
                                        </span>
                                        <ng-template #tooltipmsg3 class="">
                                            {{ "Onlinetimespentoncomputerexcludingcomputerswitchedofftimeandlockedtime" | localize }}
                                        </ng-template>
                                    </div>
                                    <div *ngIf="i == 4" class="float-right ml-2">
                                        <span placement="bottom" [tooltip]="tooltipmsg4" container="body">
                                            <i class="la la-info-circle" title=""></i>
                                        </span>
                                        <ng-template #tooltipmsg4 class="">
                                            {{ "Totaltimefromwhenyouarrivedtillleft" | localize }}
                                        </ng-template>
                                    </div>
                                    <div *ngIf="i == 5" class="float-right ml-2">
                                        <span placement="bottom" [tooltip]="tooltipmsg5" container="body">
                                            <i class="la la-info-circle" title=""></i>
                                        </span>
                                        <ng-template #tooltipmsg5 class="">
                                            {{ "Placecalculatedeffectiveness" | localize }}
                                        </ng-template>
                                    </div>
                                    <div *ngIf="i == 6" class="float-right ml-2">
                                        <span placement="bottom" [tooltip]="tooltipmsg6" container="body">
                                            <i class="la la-info-circle" title=""></i>
                                        </span>
                                        <ng-template #tooltipmsg6 class="">
                                            {{
                                                "Theeffectivenessisdefinedasaproductivetimedividedbyminimumhoursandexpressedasapercentage" | localize
                                            }}
                                        </ng-template>
                                    </div>
                                    <div *ngIf="i == 7" class="float-right ml-2">
                                        <span placement="bottom" [tooltip]="tooltipmsg7" container="body">
                                            <i class="la la-info-circle" title=""></i>
                                        </span>
                                        <ng-template #tooltipmsg7 class="">
                                            {{ "Theproductivityisdefined" | localize }}
                                        </ng-template>
                                    </div>
                                </div>
                                <div>
                                    <span class="font-weight-bolder ml-1 {{ item.class }}">
                                        <span *ngIf="i == 0">
                                            <span *ngIf="!userData.arrivalTime.hour && !userData.arrivalTime.minute"
                                                >00:00<span class="font-size-sm pl-2">{{ "h" | localize }}</span>
                                            </span>
                                            <span *ngIf="hasDisplayableArrivalTime(userData.arrivalTime)">{{ getLocalJsDate(userData.arrivalTime) | date : "hh:mm" }}</span>
                                            <span *ngIf="hasDisplayableArrivalTime(userData.arrivalTime)" class="font-size pl-1">{{
                                                getLocalJsDate(userData.arrivalTime) | date : "a" | uppercase
                                            }}</span>
                                        </span>
                                        <span *ngIf="i == 1">
                                            <span *ngIf="!userData.leftDateTime && !userData.arrivalTime?.hour && !userData.arrivalTime?.minute"
                                                >00:00<span class="font-size-sm pl-1">{{ "h" | localize }}</span>
                                            </span>
                                            <span *ngIf="!userData.leftDateTime && (userData.arrivalTime?.hour || userData.arrivalTime?.minute)"
                                                >ONLINE</span>
                                            <span *ngIf="userData.leftDateTime"
                                                >{{ getLocalJsDate(userData.leftDateTime) | date : "hh:mm  a" | uppercase }}
                                            </span>
                                        </span>
                                        <span *ngIf="i == 2"
                                            >{{ getHrsAndMinutes(userData.productivityTime)
                                            }}<span class="font-size-sm pl-1"> {{ "h" | localize }}</span></span
                                        >
                                        <span *ngIf="i == 3"
                                            >{{ getHrsAndMinutes(userData.trackedTime)
                                            }}<span class="font-size-sm pl-1"> {{ "h" | localize }}</span></span
                                        >
                                        <span *ngIf="i == 4"
                                            >{{ getHrsAndMinutes(userData.timeAtWork)
                                            }}<span class="font-size-sm pl-1"> {{ "h" | localize }}</span></span
                                        >
                                        <span *ngIf="i == 5">{{ userData.rank }}</span
                                        ><sup
                                            ><span *ngIf="i == 5" class="font-size-sm pl-1">{{ userData.rank | ordinalDate }}</span></sup
                                        >
                                        <span *ngIf="i == 6"
                                            >{{ getTrimmedPercentage(userData.effectiveness) }}<span class="font-size-sm pl-1">%</span></span
                                        >
                                        <span *ngIf="i == 7"
                                            >{{ getTrimmedPercentage(productivityPercentage) }}<span class="font-size-sm pl-1">%</span></span
                                        >
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="isLoaded && !isEmpty">
                            <div *ngIf="i == 4" class="ml-10">
                                <span>
                                    <div class="progress-wrapper">
                                        <div class="current" [ngStyle]="getOverlayStyle()">{{ currentTimeAtWork }}%</div>
                                        <round-progress
                                            [current]="currentTimeAtWork"
                                            [max]="max"
                                            [color]="gradient ? 'url(#gradient)' : color"
                                            [background]="background"
                                            [radius]="radius"
                                            [stroke]="stroke"
                                            [clockwise]="clockwise"
                                            [responsive]="responsive"
                                        ></round-progress>
                                    </div>
                                </span>
                            </div>

                            <div *ngIf="i == 3" class="ml-10">
                                <span>
                                    <div class="progress-wrapper">
                                        <div class="current" [ngStyle]="getOverlayStyle()">{{ currentActiveTime }}%</div>
                                        <round-progress
                                            [current]="currentActiveTime"
                                            [max]="max"
                                            [color]="gradient ? 'url(#gradient)' : color"
                                            [background]="background"
                                            [radius]="radius"
                                            [stroke]="stroke"
                                            [clockwise]="clockwise"
                                            [responsive]="responsive"
                                        ></round-progress>
                                    </div>
                                </span>
                            </div>

                            <div *ngIf="i == 0">
                                <span>
                                    <div class="progress-wrapper-ArrivalTime">
                                        <img
                                            *ngIf="LateBy && userData.arrivalTime.hour"
                                            class="imageAlign border border-light rounded h-15px w-15px"
                                            src="/assets/common/images/photos/imageDashboard.png"
                                        />
                                        <p *ngIf="LateBy && userData.arrivalTime.hour" class="m-0 text-danger" style="font-size: 13">
                                            {{ "LateBy" | localize }}
                                        </p>
                                        <p *ngIf="LateBy && userData.arrivalTime.hour" class="text-danger" style="font-size: 13">
                                            {{ lateByTime }} h
                                        </p>
                                        <img
                                            *ngIf="EarlyBy && userData.arrivalTime.hour"
                                            class="imageAlign border border-light rounded h-15px w-15px"
                                            src="/assets/common/images/photos/DashboardEarlyBy.png"
                                        />
                                        <p *ngIf="EarlyBy && userData.arrivalTime.hour" class="m-0 text-success" style="font-size: 13">
                                            {{ "EarlyBy" | localize }}
                                        </p>
                                        <p *ngIf="EarlyBy && userData.arrivalTime.hour" class="text-success" style="font-size: 13">
                                            {{ EarlyByTime }} h
                                        </p>
                                        <img
                                            *ngIf="onTime && userData.arrivalTime.hour"
                                            class="imageAlign border border-light rounded h-15px w-15px"
                                            src="/assets/common/images/photos/DashboardEarlyBy.png"
                                        />
                                        <p *ngIf="onTime && userData.arrivalTime.hour" class="m-0 text-primary" style="font-size: 13">
                                            {{ "On Time" | localize }}
                                        </p>
                                    </div>
                                </span>
                            </div>
                            <div *ngIf="i == 1">
                                <span *ngIf="userData.leftDateTime">
                                    <div class="progress-wrapper-ArrivalTime">
                                        <img
                                            *ngIf="EarlyBy && !leftOnTime"
                                            class="imageAlign border border-light rounded h-15px w-15px"
                                            src="/assets/common/images/photos/imageDashboard.png"
                                        />
                                        <p *ngIf="EarlyBy && !leftOnTime" class="m-0 text-danger" style="font-size: 13">
                                            {{ "EarlyBy" | localize }}
                                        </p>
                                        <p *ngIf="EarlyBy && !leftOnTime" class="text-danger" style="font-size: 13">{{ leftByTime }} h</p>
                                        <img
                                            *ngIf="leftOnTime"
                                            class="imageAlign border border-light rounded h-15px w-15px"
                                            src="/assets/common/images/photos/imageDashboard.png"
                                        />
                                        <p *ngIf="leftOnTime" class="m-0 text-primary" style="font-size: 13">
                                            {{ "Left On Time" | localize }}
                                        </p>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
